import { render, staticRenderFns } from "./IndustriesSelect.vue?vue&type=template&id=179a45a0&"
import script from "./IndustriesSelect.vue?vue&type=script&lang=ts&setup=true&"
export * from "./IndustriesSelect.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports